import { ImageModifierController } from "../ImageModifierController.svelte"

type View = "default" | "new-mask" | "edit-mask" | "remove"

export class SidebarCntl {
	view: View = $state("default")
	showDetails = $state(true)

	setView = (view: View) => {
		this.view = view
	}

	toggleDetails = () => {
		this.showDetails = !this.showDetails
	}

	skipToMaskCreation = async (controller: ImageModifierController) => {
		this.view = "new-mask"
		try {
			await controller.createMask("freedraw", "Facade")
		} catch (e) {
			console.error("An error ocurred while trying to create a new mask.", e)
		}
		this.view = "default"
	}
}

export const SidebarController = new SidebarCntl()
